import { useContext } from "react"

import { Button } from "reactstrap"

import { ScenarioContext } from "../../contexts/ScenarioContext"

const ScenarioInfoButton = () => {
    const { setPaused } = useContext(ScenarioContext)

    return (
        <Button
            size="sm"
            color="primary"
            onClick={() => setPaused(true)}
            className="navbar-btn"
        >
            Info
        </Button>
    )
}

export default ScenarioInfoButton
